<template>
  <div class="tool">
    <a-tooltip placement="right" :getPopupContainer="(target) => target.parentNode" class="icon">
      <template #title>锚点框</template>
      <a-icon type="scan" @click="changeTool('anchor')" class="iconBtn" />
    </a-tooltip>
    <a-tooltip placement="right">
      <template #title>内容框</template>
      <a-icon type="scan" @click="changeTool('rectangle')" class="iconBtn" />
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: 'Tool',
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    changeTool(eventName) {
      this.$emit('toolSelected', eventName)
    }
  }
}
</script>

<style lang="less" scoped>
.tool {
  width: 30px;
  margin: 0px 5px;
}

.iconBtn {
  box-sizing: border-box;
  height: 30px;
  width: 30px;
  line-height: 30px;
  font-size: 20px;
  padding: 0 5px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.4);
  cursor: pointer;

  &:nth-child(1) {
    margin-top: 5px;
  }

  &:hover {
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.4);
  }
}
</style>
